import { SOKOBAN_LEVELS, SOKOBAN_MAP_WIDTH, SOKOBAN_MAP_HEIGHT } from "./levels";

const buildPath = () => {
  if (SOKOBAN_LEVELS.length === 0) return "";
  const head = SOKOBAN_LEVELS[0];
  let d = `M ${head.x} ${head.y}`;
  for (let i = 1; i < SOKOBAN_LEVELS.length; i += 1) {
    const prev = SOKOBAN_LEVELS[i - 1];
    const curr = SOKOBAN_LEVELS[i];
    const cx = (prev.x + curr.x) / 2;
    d += ` Q ${cx} ${prev.y}, ${cx} ${(prev.y + curr.y) / 2}`;
    d += ` T ${curr.x} ${curr.y}`;
  }
  return d;
};

const ROAD_PATH = buildPath();

interface CloudDef {
  cx: number;
  cy: number;
  r: number;
}

const CLOUDS: CloudDef[] = Array(20)
  .fill(0)
  .map((_, i) => ({
    cx: 120 + i * 480 + ((i * 173) % 200),
    cy: 60 + ((i * 97) % 80),
    r: 38 + ((i * 53) % 24),
  }));

interface IslandDef {
  cx: number;
  cy: number;
  rx: number;
  ry: number;
  hue: string;
}

const ISLANDS: IslandDef[] = Array(14)
  .fill(0)
  .map((_, i) => ({
    cx: 320 + i * 700 + ((i * 211) % 220),
    cy: 470 + ((i * 67) % 50),
    rx: 120 + ((i * 47) % 60),
    ry: 36 + ((i * 23) % 16),
    hue: i % 2 === 0 ? "#9bd6a3" : "#bce5b5",
  }));

export const MapDecorations = () => (
  <svg
    width={SOKOBAN_MAP_WIDTH}
    height={SOKOBAN_MAP_HEIGHT}
    viewBox={`0 0 ${SOKOBAN_MAP_WIDTH} ${SOKOBAN_MAP_HEIGHT}`}
    className="absolute top-0 left-0 pointer-events-none"
  >
    {ISLANDS.map((island, idx) => (
      <ellipse
        key={`island-${idx}`}
        cx={island.cx}
        cy={island.cy}
        rx={island.rx}
        ry={island.ry}
        fill={island.hue}
        opacity={0.7}
      />
    ))}

    {CLOUDS.map((cloud, idx) => (
      <g key={`cloud-${idx}`} opacity={0.85}>
        <circle cx={cloud.cx} cy={cloud.cy} r={cloud.r} fill="#ffffff" />
        <circle cx={cloud.cx + cloud.r * 0.7} cy={cloud.cy + 4} r={cloud.r * 0.8} fill="#ffffff" />
        <circle cx={cloud.cx - cloud.r * 0.7} cy={cloud.cy + 4} r={cloud.r * 0.75} fill="#ffffff" />
      </g>
    ))}

    <path
      d={ROAD_PATH}
      fill="none"
      stroke="#ffffff"
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={0.8}
    />
    <path
      d={ROAD_PATH}
      fill="none"
      stroke="#7fb8d8"
      strokeWidth={6}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="14 12"
      opacity={0.9}
    />
  </svg>
);
